import axios from "axios";
import { getApiBaseUrl, getApiClient } from "./serviceconfig";

// export async function getLogo() {
//   let url= `${getApiBaseUrl()}/login/`;
//     return axios.get(url)
//       .then(response => response.data);
// }

export async function getBgImageLogo() {
  const url = `${getApiBaseUrl()}/set_bg_image_logo/`;
  try {
    const response = await axios.get(url, { timeout: 10000 });
    return { ...response.data, apiOffline: false };
  } catch (error) {
    console.warn('Unable to load background/logo settings:', error?.message || error);
    return { company_list: [], plant_list: [], apiOffline: true };
  }
}

export async function submitLogin(user_name, password,otp,latitude,longitude) {
    const apiBaseUrl = getApiBaseUrl();
    const payload = {
                username: String(user_name || '').trim(),
                password: String(password ?? ''),
                otp : otp ? String(otp).trim() : null,
                latitude: Number(latitude) || 0,
                longitude: Number(longitude) || 0,
              };
    return axios.post(`${apiBaseUrl}/login/`, payload)
            .then(response => {
                return response.data;
            });
}

export async function performLogout(cookies) {
  return getApiClient(cookies).post(`${getApiBaseUrl()}/logout/`);
}